require('./myWalletActualTab.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');

// @helpers
const { formatText } = require('core/i18n').i18n;
const { recordLinkV2 } = require('utilities/tagging');

// @components
const Reference = require('../myWalletComponents/reference');
const WalletValues = require('../myWalletComponents/walletValues');
const MyWalletEmptyState = require('../myWalletComponents/myWalletEmptyState');
const StartToInvestButton = require('../myWalletComponents/startToInvestButton');
const MyWalletValuesModal = require('../myWalletValuesModal/myWalletValuesModal');

// @commons
const DonutChart = require('components/d3Components/donutChart/donutChart');
const { LoadingSection } = require('commonsComponents/loadingSection');


// @constants
const {
    MYPROFILE_BROKER_STOCKS_URL,
    MYPROFILE_BROKER_ETFS_URL,
    MYPROFILE_BROKER_WARRANTS_URL,
    MYPROFILE_BROKER_FUNDS_URL,
    MYPROFILE_BROKER_FUTURES_URL,
    MYPROFILE_BROKER_PLANS_URL,
    MYPROFILE_BROKER_LESS_THAN_ONE,
    ALTERNATIVE_FUNDS,
    MYPROFILE_BROKER_ALTERNATIVE_FUNDS_URL,
    MYPROFILE_BROKER_CRYPTO_URL
} = require('constants/index');

const { SHOW_GLOBAL_POSITION_VENTURE_CAPITAL_FUNDS } = require('constants/flagBasedFeatures');

class ProductTypesTab extends React.Component {
    constructor(props) {
        super(props);
    }

    formatPercentage(percentage, itemsNumber) {
        let roundedValue;

        if ((percentage > 0 && percentage < 1) || (percentage === 0 && itemsNumber > 0)) {
            roundedValue = MYPROFILE_BROKER_LESS_THAN_ONE;
        } else {
            //same behavior than Math.round but 0.5 cases will be rounded down.
            roundedValue = -Math.round(-percentage);
        }
        return roundedValue.toString();
    }

    buildReferences() {
        const { immMyWalletCharts, immStocksByType, flagBasedFeatures } = this.props;

        const hasInvestments = immMyWalletCharts.get('hasInvestments');
        const totalInvestmentAmount = immMyWalletCharts.getIn(['totalInvestment', 'amount']);
        const links = {
            stocks: MYPROFILE_BROKER_STOCKS_URL,
            warrants: MYPROFILE_BROKER_WARRANTS_URL,
            etfs: MYPROFILE_BROKER_ETFS_URL,
            plans: MYPROFILE_BROKER_PLANS_URL,
            funds: MYPROFILE_BROKER_FUNDS_URL,
            alternativeFunds: MYPROFILE_BROKER_ALTERNATIVE_FUNDS_URL,
            crypto: MYPROFILE_BROKER_CRYPTO_URL,
            futures: MYPROFILE_BROKER_FUTURES_URL
        };

        const modCss = {
            etfs: 'etfs',
            alternativeFunds: 'alternative-funds'
        }

        return immMyWalletCharts.get('percentages').map(item => {
          const label = item.get('label');
          const itemsNumber = immStocksByType.getIn([label, 'total']);
          const percentage = this.formatPercentage(item.get('value'), itemsNumber);
          const name =
            label === 'etfs' ? formatText('broker-labelETFETPETC') : formatText(`broker-${label}`);

          const modifierClass = modCss[label];
          const ffShowReferenceAlternativeFunds = flagBasedFeatures.get(
            SHOW_GLOBAL_POSITION_VENTURE_CAPITAL_FUNDS
          );

          if (
            (ffShowReferenceAlternativeFunds && label === ALTERNATIVE_FUNDS) ||
            label !== ALTERNATIVE_FUNDS
          ) {
            return (
              <Reference
                key={item.get('label')}
                id={item.get('label')}
                name={name}
                percentage={percentage}
                hasInvestments={hasInvestments}
                totalInvestmentAmount={totalInvestmentAmount}
                link={links[label]}
                modifierClass={modifierClass}
              />
            );
          }
        });
    }

    buildDonutChart() {
        const {
            immMyWalletCharts,
        } = this.props;

        const dataset = immMyWalletCharts.get('percentages');
        const totalInvestmentAmount = immMyWalletCharts.getIn(['totalInvestment', 'amount'], 0);

        return (
            <DonutChart
                width="180"
                height="180"
                donutWidth="35"
                dataset={dataset.map(item => {
                    return item.set('label', formatText(`broker-${item.get('label')}`)).set('key', item.get('label'));
                })}
                namespace="my-wallet-actual-tab"
                totalInvestmentAmount={totalInvestmentAmount}
                valueFormatFunction={this.formatPercentage}
            />
        );
    }

    handleClickForTagging() {
        const startToInvestData = {
            categoriaEvento: 'myPortfolioHomeInteraction',
            accionEvento: 'myPortfolioCard',
            etiquetaEvento: 'startInvesting'
        };
        recordLinkV2(startToInvestData);
    }

    getContent() {
        const {
            immMyWalletCharts,
            onToggleModal,
            immBrokerMyInvestments
        } = this.props;

        const summarizationData = immMyWalletCharts.get('summarizationData');
        const hasInvestments = immMyWalletCharts.get('hasInvestments');
        const hasPendingOperations = immMyWalletCharts.get('hasPendingOperations');
        const isCustomWalletSelected = immMyWalletCharts.get('isCustomWalletSelected');
        const startToInvestButton = !hasInvestments && !isCustomWalletSelected
            ? (
                <StartToInvestButton
                    label={formatText('broker-miCarteraEmptyStateCTALabel')}
                    onClick={this.handleClickForTagging}
                />) : null;
        const donutChart = this.buildDonutChart();
        const references = this.buildReferences();
        const modaleIsOpen = immMyWalletCharts.get('showModal')

        return (
            <div>
                <div>
                    <div className="my-wallet-actual-tab__donut-container col-xs-4">
                        {donutChart}
                    </div>
                    <div className="my-wallet-actual-tab__content col-xs-8">
                        <WalletValues
                            immMyWalletCharts={immMyWalletCharts}
                            handleHowCalculateOnClick={onToggleModal}
                            immBrokerMyInvestments={immBrokerMyInvestments}
                        />
                    </div>
                    <div className="my-wallet-actual-tab__ref-container col-xs-12">
                        {references}
                    </div>
                    {startToInvestButton}
                </div>
                <MyWalletValuesModal
                    isOpen={modaleIsOpen}
                    onRequestClose={onToggleModal}
                    hasPendingOperations={hasPendingOperations}
                    onToggleModal={onToggleModal}
                    summarization={summarizationData}
                />
            </div>
        )
    }

    render() {
        const {
            immMyWalletCharts,
            isFetchingMyInvestment,
            handleRetry,
            brokerMyInvestmentsErrorReceived
        } = this.props;

        let tabContent;


        if (isFetchingMyInvestment) {
            tabContent = <LoadingSection />;
        } else if (immMyWalletCharts.get('fetchError') || brokerMyInvestmentsErrorReceived) {
            tabContent = MyWalletEmptyState(handleRetry);
        } else if (!immMyWalletCharts.get('fetchError') && !brokerMyInvestmentsErrorReceived) {
            tabContent = this.getContent();
        }

        return (
            <div className="my-wallet-actual-tab row">
                {tabContent}
            </div>
        );
    }
}

ProductTypesTab.propTypes = {
    immMyWalletCharts: PropTypes.object.isRequired,
    immBrokerMyInvestments: PropTypes.object.isRequired,
    immStocksByType: PropTypes.object.isRequired,
    handleRetry: PropTypes.func.isRequired,
    onToggleModal: PropTypes.func.isRequired,
    brokerMyInvestmentsErrorReceived: PropTypes.bool,
    isFetchingMyInvestment: PropTypes.bool
};

module.exports = ProductTypesTab;
